// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORMS_DEFAULT_EMAIL_FIELD_FORMAT_ERROR = "Toto nevyzer\u00e1 ako spr\u00e1vny email.";
export const FORMS_DEFAULT_NUMBER_FIELD_FORMAT_ERROR = "Toto pole by malo by\u0165 \u010d\u00edslo.";
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
